module.exports = __webpack_public_path__ + "static/media/result_vi_ja.12c48fad.jpg";